export default __webpack_public_path__ + "e58e1728a1985d62b40a506f62879b24.png";